// extracted by mini-css-extract-plugin
export default {"form":"EditProjectModal_form__sXzyX","row":"EditProjectModal_row__Sn7M0","footer":"EditProjectModal_footer__-9Ziz"};